export enum StatusProcesso {
    Ativo = 1,
    Encerrado = 2,
    NaoProcessadoNaPlataforma = 3,
    EmPreAnalise = 4,
    RetiradoPeloCliente = 5,
    AssumidoPeloCedente = 6,
    Cancelado = 99,
}
